module.exports = __webpack_public_path__ + "static/media/nft-29.2c1d6176.jpg";